import React from "react";
import ReactMarkdown, { Components } from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";

interface MarkdownPageProps {
  content: string;
}

// Markdown has no video syntax, so an image link to an .mp4 renders as an inline video player,
// with the link title as its poster image: `![alt](/videos/x.mp4 "/videos/x-poster.jpg")`.
const markdownComponents: Components = {
  img: ({ src, alt, title }) => {
    if (src?.endsWith(".mp4")) {
      return (
        <video
          src={src}
          poster={title}
          controls
          playsInline
          preload="metadata"
          aria-label={alt}
        />
      );
    }
    return <img src={src} alt={alt} />;
  },
};

const MarkdownPage: React.FC<MarkdownPageProps> = ({ content }) => {
  return (
    <div className="cs-markdown-page">
      <ReactMarkdown remarkPlugins={[remarkGfm, remarkBreaks]} components={markdownComponents}>
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownPage;
